<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="stockTransformations.data"
      style="width: 100%"
      row-key="id"
      highlight-current-row
      :row-class-name="'pointer-row'"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="70"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="stockTransformation"
            :options="['settings', 'export']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :stock-transformation="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="stockTransformations.per_page"
        layout="total, prev, pager, next"
        :total="stockTransformations.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'created_at',
          order: 'asc',
        },
      };
    },
    computed: {
      stockTransformations() {
        return this.$store.getters['stockTransformation/stockTransformations'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['stockTransformation/tableConfig']));
      },
      loading() {
        return this.$store.getters['stockTransformation/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('stockTransformation/setFilterString', '');
      this.$store.commit('stockTransformation/setCurrentPage', this.currentPage);
      this.$store.commit('stockTransformation/setSorting', this.currentSort);
      await this.$store.dispatch('stockTransformation/fetchAll');
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('stockTransformation/setCurrentPage', val);
        this.$store.dispatch('stockTransformation/fetchAll');
      },
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('stockTransformation/setSorting', { prop, order });
          this.$store.dispatch('stockTransformation/fetchAll');
        }
      },
    },
  };
</script>


